/* eslint-disable no-mixed-spaces-and-tabs */
/* eslint-disable react/jsx-wrap-multilines */
import React, { useEffect } from 'react';
import { createStructuredSelector } from 'reselect';
import { connect } from 'react-redux';
import { reset, submit } from 'redux-form';
import { useHistory, useLocation } from 'react-router';
import PropTypes from 'prop-types';
import { useInjectSaga } from '../../utils/injectSaga';
import saga from './saga';
import { useInjectReducer } from '../../utils/injectReducer';
import reducer from './reducer';
import { ModalWindow } from '../../semantic-ui/components/modal-window';
import ModalFooterButtons from '../../semantic-ui/components/modal-window/modal-footer-buttons';
import {
	getIcepacksAction,
	getIcepacksFillersAction,
	getIcepacksStatesAction,
	getModesAction,
	getIcepackFilledInfoAction,
	createIcepackFilledAction,
	updateIcepackFilledAction,
	deleteIcepackFilledAction,
	resetIcepackFilledModalAction,
} from './actions';
import {
	getIsModalShownSelector,
	getIsIcepackFilledAddFormOpenSelector,
	getIsIcepackFilledEditFormOpenSelector,
	getIsIcepackFilledCreatingSelector,
	getIsIcepackFilledUpdatingSelector,
	getIsIcepackFilledDeletingSelector,
	getActiveIcepackFilledIdSelector,
	getIsAuditTabShownSelector,
	getIcepackFilledInfoSelector,
	getIsIcepackFilledInfoLoadingSelector,
	getIcepackFilledNameSelector,
} from './selectors';
import { ICEPACK_FORM_NAME } from './constants';
import { IcepackFilledModalContent } from './components/icepack-filled-modal-content';
import { Audit } from '../../components/audit';
import { getIsAvailableIcepacksFilledButtonsSelector } from '../profile/selectors';
import closeModal from '../../utils/closeModal';
import { setWindowInfoAction } from '../alert-modal/actions';
import { removeModalQuery } from '../../utils/removeModalQuery';

const IcepackModalWrapper = ({
	isAvailable,
	isModalShown,
	isIcepackFilledAddFormOpen,
	isIcepackFilledEditFormOpen,
	isIcepackFilledCreating,
	isIcepackFilledUpdating,
	isIcepackFilledDeleting,
	activeIcepackFilledId,
	isAuditTabShown,
	icepackFilledInfo,
	isIcepackFilledInfoLoading,
	icepackFilledName,
	onFormSubmit,
	onClearForm,
	onResetState,
	onGetIcepacks,
	onGetIcepacksFillers,
	onGetIcepacksStates,
	onGetModes,
	onCreateIcepackFilled,
	onUpdateIcepackFilled,
	onDeleteIcepackFilled,
	onGetIcepackFilledInfo,
	onSetWindowInfo,
}) => {
	if (!isModalShown) return null;
	useInjectSaga({ key: 'icepackFilledModalSaga', saga });
	useInjectReducer({ key: 'icepackFilledModalReducer', reducer });

	const { search, pathname } = useLocation();

	const query = new URLSearchParams(search);

	const modal = query.get('modal');

	const mode = query.get('mode');

	const history = useHistory();

	useEffect(() => {
		if (isIcepackFilledAddFormOpen || isIcepackFilledEditFormOpen) {
			onGetIcepacks();
			onGetIcepacksFillers();
			onGetIcepacksStates();
			onGetModes();
		}
	}, [isIcepackFilledAddFormOpen, isIcepackFilledEditFormOpen]);

	useEffect(() => {
		if (activeIcepackFilledId) {
			onGetIcepackFilledInfo(activeIcepackFilledId);
		}
	}, [activeIcepackFilledId]);

	const handleModalClose = () => {
		closeModal(query);

		onClearForm();
		onResetState();

		history.push(`${pathname}?${query}`);
	};

	const handleNavItemClick = target => {
		if (target === 'audit') {
			query.set('tab', 'audit');
		} else {
			query.set('modal', target);
			query.delete('tab');
		}

		if (mode) {
			query.delete('mode');
		}

		history.push(`${pathname}?${query}`);
	};

	const handleIcepackFilledFormOpenButtonClick = mode => {
		if (activeIcepackFilledId) {
			query.set('id', activeIcepackFilledId);
		} else {
			query.delete('id');
		}

		if (mode === 'edit') {
			query.set('mode', 'edit');
		}

		if (mode === 'cancel') {
			onClearForm();
			query.delete('mode');
		}

		if (mode === 'cancel' && !activeIcepackFilledId) {
			onResetState();
			query.delete('modal');
		}

		history.push(`${pathname}?${query}`);
	};

	const handleIcepackFilledFormSubmit = async () => {
		await onFormSubmit(ICEPACK_FORM_NAME);

		if (activeIcepackFilledId) {
			onUpdateIcepackFilled({
				id: activeIcepackFilledId,
				searchQuery: removeModalQuery(query.toString()),
				redirect: () => handleIcepackFilledFormOpenButtonClick('cancel'),
			});

			return;
		}

		onCreateIcepackFilled({
			redirect: handleModalClose,
			searchQuery: removeModalQuery(query.toString()),
		});
	};

	const handleKeyDown = e => {
		if (e.key === 'Enter' && e.shiftKey === false) {
			handleIcepackFilledFormSubmit();
		}
	};

	const handleIcepackDelete = () => {
		onSetWindowInfo({
			type: 'delete',
			title: 'Вы уверены?',
			text: 'Вы не сможете это отменить',
			button: {
				type: 'success',
				text: 'Да, удалить',
				onClick: () =>
					onDeleteIcepackFilled({
						id: activeIcepackFilledId,
						redirect: handleModalClose,
						searchQuery: removeModalQuery(query.toString()),
					}),
			},
		});
	};

	return (
		<ModalWindow
			isLoading={isIcepackFilledInfoLoading}
			isModalShown={isModalShown}
			onKeyDown={handleKeyDown}
			onClose={handleModalClose}
			navItems={
				isIcepackFilledAddFormOpen || isIcepackFilledEditFormOpen
					? []
					: [
							{
								id: 'info',
								text: 'Информация',
								onClick: () => handleNavItemClick('icepack_filled'),
								isActive: modal === 'icepack_filled' && !isAuditTabShown,
							},
							{
								id: 'audit',
								text: 'Изменения',
								onClick: () => handleNavItemClick('audit'),
								isActive: isAuditTabShown,
							},
					  ]
			}
			headerText={
				isIcepackFilledAddFormOpen || isIcepackFilledEditFormOpen
					? `${
							isIcepackFilledEditFormOpen
								? 'Изменить хладоэлемент с наполнителем'
								: 'Создать хладоэлемент с наполнителем'
					  }`
					: icepackFilledName
			}
			modalContent={
				!isAuditTabShown ? (
					<IcepackFilledModalContent
						isLoading={isIcepackFilledInfoLoading}
						icepackFilledInfo={icepackFilledInfo}
						isIcepackFilledFormOpen={isIcepackFilledAddFormOpen || isIcepackFilledEditFormOpen}
					/>
				) : (
					<Audit entityName="icepacks_filled" entityId={activeIcepackFilledId} />
				)
			}
			style={{ width: '895px' }}
			actionButtons={[{ type: 'close', onClick: handleModalClose, text: 'profile' }]}
			footerButtons={
				<ModalFooterButtons
					leftButtons={
						!(isIcepackFilledAddFormOpen || isIcepackFilledEditFormOpen) &&
						isAvailable.delete &&
						!isAuditTabShown
							? [
									{
										onClick: handleIcepackDelete,
										text: 'Удалить',
										color: 'warning',
										disabled: isIcepackFilledInfoLoading || isIcepackFilledDeleting,
									},
							  ]
							: []
					}
					rightButtons={
						isIcepackFilledAddFormOpen || isIcepackFilledEditFormOpen
							? [
									{
										onClick: handleIcepackFilledFormSubmit,
										text: 'Сохранить',
										color: 'primary',
										loading: isIcepackFilledCreating || isIcepackFilledUpdating,
										disabled:
											isIcepackFilledInfoLoading ||
											isIcepackFilledCreating ||
											isIcepackFilledUpdating,
									},
									{
										onClick: () => handleIcepackFilledFormOpenButtonClick('cancel'),
										text: 'Отмена',
										color: 'secondary',
										disabled: isIcepackFilledCreating || isIcepackFilledUpdating,
									},
							  ]
							: [
									...(isAvailable.update && !isAuditTabShown
										? [
												{
													onClick: () => handleIcepackFilledFormOpenButtonClick('edit'),
													text: 'Изменить',
													color: 'primary',
													disabled: isIcepackFilledInfoLoading || isIcepackFilledDeleting,
												},
										  ]
										: []),
									{
										onClick: handleModalClose,
										text: 'Закрыть',
										color: 'secondary',
									},
							  ]
					}
				/>
			}
		/>
	);
};

const mapStateToProps = createStructuredSelector({
	isAvailable: getIsAvailableIcepacksFilledButtonsSelector(),
	isModalShown: getIsModalShownSelector(),
	isIcepackFilledAddFormOpen: getIsIcepackFilledAddFormOpenSelector(),
	isIcepackFilledEditFormOpen: getIsIcepackFilledEditFormOpenSelector(),
	isIcepackFilledCreating: getIsIcepackFilledCreatingSelector(),
	isIcepackFilledUpdating: getIsIcepackFilledUpdatingSelector(),
	isIcepackFilledDeleting: getIsIcepackFilledDeletingSelector(),
	activeIcepackFilledId: getActiveIcepackFilledIdSelector(),
	isAuditTabShown: getIsAuditTabShownSelector(),
	isIcepackFilledInfoLoading: getIsIcepackFilledInfoLoadingSelector(),
	icepackFilledInfo: getIcepackFilledInfoSelector(),
	icepackFilledName: getIcepackFilledNameSelector(),
});

const mapDispatchToProps = {
	onFormSubmit: submit,
	onClearForm: () => reset(ICEPACK_FORM_NAME),
	onResetState: resetIcepackFilledModalAction,
	onGetIcepacks: getIcepacksAction,
	onGetIcepacksFillers: getIcepacksFillersAction,
	onGetIcepacksStates: getIcepacksStatesAction,
	onGetModes: getModesAction,
	onCreateIcepackFilled: createIcepackFilledAction,
	onUpdateIcepackFilled: updateIcepackFilledAction,
	onDeleteIcepackFilled: deleteIcepackFilledAction,
	onGetIcepackFilledInfo: getIcepackFilledInfoAction,
	onSetWindowInfo: setWindowInfoAction,
};

IcepackModalWrapper.propTypes = {
	isAvailable: PropTypes.objectOf(PropTypes.bool),
	isModalShown: PropTypes.bool.isRequired,
	isIcepackFilledAddFormOpen: PropTypes.bool.isRequired,
	isIcepackFilledEditFormOpen: PropTypes.bool.isRequired,
	isIcepackFilledCreating: PropTypes.bool.isRequired,
	isIcepackFilledUpdating: PropTypes.bool.isRequired,
	isIcepackFilledDeleting: PropTypes.bool.isRequired,
	activeIcepackFilledId: PropTypes.string,
	isAuditTabShown: PropTypes.bool.isRequired,
	isIcepackFilledInfoLoading: PropTypes.bool.isRequired,
	icepackFilledInfo: PropTypes.arrayOf(
		PropTypes.shape({
			id: PropTypes.string.isRequired,
			title: PropTypes.string.isRequired,
			value: PropTypes.oneOfType([
				PropTypes.string,
				PropTypes.shape({
					name: PropTypes.string,
					role: PropTypes.string,
				}),
			]).isRequired,
		}),
	),
	icepackFilledName: PropTypes.string.isRequired,
	onFormSubmit: PropTypes.func.isRequired,
	onClearForm: PropTypes.func.isRequired,
	onResetState: PropTypes.func.isRequired,
	onGetIcepacks: PropTypes.func.isRequired,
	onGetIcepacksFillers: PropTypes.func.isRequired,
	onGetIcepacksStates: PropTypes.func.isRequired,
	onGetModes: PropTypes.func.isRequired,
	onCreateIcepackFilled: PropTypes.func.isRequired,
	onUpdateIcepackFilled: PropTypes.func.isRequired,
	onDeleteIcepackFilled: PropTypes.func.isRequired,
	onGetIcepackFilledInfo: PropTypes.func.isRequired,
	onSetWindowInfo: PropTypes.func.isRequired,
};

const IcepackFilledModal = connect(mapStateToProps, mapDispatchToProps)(IcepackModalWrapper);

export default IcepackFilledModal;
